import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { driversPath, makeSearchPath } from '@/utils'
import { DriverNode } from '@/apollo/graphql'

interface IDriverRow {
  node: DriverNode
}

const DriverRow: React.FC<IDriverRow> = ({ node }) => {
  const navigate = useNavigate()
  const { customerId } = useParams()

  return (
    <tr
      onClick={() =>
        navigate(
          makeSearchPath(driversPath, {
            customerId,
            id: node.id,
          }),
        )
      }
    >
      <td>{node.id}</td>
      <td>{node.name}</td>
    </tr>
  )
}

export default DriverRow
